import React, { useState } from 'react';
import { Card, Row, Col, Button, Table, Modal, Form, Pagination } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { LICHHOCTHUCHANH_API } from '../../../utils/apiUrl';
import { Get, Post } from '../../../utils/httpProvider';
import { toast } from 'react-toastify';
import moment from 'moment';

const InstructorAgendaView = ({ contractId, selectedInstructorId, onNavigateToAttendance }) => {

    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;

    React.useEffect(() => {
        setCurrentPage(1);
    }, [selectedInstructorId]);

    // Fetch the agenda data
    const { data, isLoading, error, refetch: refetchAgenda } = useQuery(
        ['instructorAgenda', contractId, selectedInstructorId],
        () => {
            let url = LICHHOCTHUCHANH_API.GET_INSTRUCTOR_AGENDA;
            const params = [];
            if (contractId) {
                params.push(`hopDongChiTietId=${contractId}`);
            }
            if (selectedInstructorId) {
                params.push(`instructorAccountId=${selectedInstructorId}`);
            }
            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }
            return Get(url).then(res => res?.data || res);
        },
        {
            enabled: !!contractId && !!selectedInstructorId
        }
    );

    const handleDownloadCsv = () => {
        const list = data?.cacTuanTiepTheo || [];
        if (list.length === 0 && (!data?.tuanNay?.hocViens || data.tuanNay.hocViens.length === 0)) {
            toast.info("Không có dữ liệu lịch để xuất.");
            return;
        }

        let csvContent = "\ufeff";
        csvContent += "Tuần thực hành,Học viên lâm sàng,Chuyên ngành,Trạng thái\n";

        if (data?.tuanNay?.hocViens && data.tuanNay.hocViens.length > 0) {
            data.tuanNay.hocViens.forEach(h => {
                csvContent += `"Tuần này (${data.tuanNay.rangeStr})","${h.hocVienTen}","${h.chuyenNganh}","Đang học"\n`;
            });
        }

        list.forEach(row => {
            csvContent += `"${row.rangeStr}","${row.hocVienTen}","${row.chuyenNganh}","${row.isNewStudent ? 'Nhận học viên mới' : 'Bình thường'}"\n`;
        });

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `lich_giang_day_${selectedInstructorId}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (isLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-teal spinner-border-sm mr-2" role="status"></div>
                <span className="text-muted font-weight-bold">Đang tải lịch giảng dạy...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger m-0">
                Lỗi tải lịch giảng dạy.
            </div>
        );
    }

    if (!data) {
        return (
            <Card className="text-center py-4 border-light bg-light">
                <Card.Body className="text-muted">Chọn giảng viên để hiển thị bảng phân công hướng dẫn.</Card.Body>
            </Card>
        );
    }

    const nextWeeks = data?.cacTuanTiepTheo || [];
    const tuanNayRange = data?.tuanNay?.rangeStr || '';

    return (
        <div className="p-1">
            <style>{`
                .clinical-tutor-card {
                    border-radius: 12px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
                    border: 1px solid #e2e8f0;
                }
                .tutor-badge-new {
                    font-size: 0.75rem;
                    padding: 4px 8px;
                    border-radius: 6px;
                    font-weight: 600;
                    background-color: #fef3c7;
                    color: #d97706;
                    border: 1px solid #fde68a;
                }
                .tutor-badge-normal {
                    font-size: 0.75rem;
                    padding: 4px 8px;
                    border-radius: 6px;
                    font-weight: 500;
                    background-color: #f1f5f9;
                    color: #475569;
                    border: 1px solid #cbd5e1;
                }
                .tutor-badge-schedule {
                    font-size: 0.75rem;
                    padding: 4px 8px;
                    border-radius: 4px;
                    font-weight: 500;
                    background-color: #f1f5f9;
                    color: #475569;
                    border: 1px solid #cbd5e1;
                }
                .clinical-tutor-table {
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    border-radius: 8px;
                    overflow: hidden;
                }
                .clinical-tutor-table th {
                    background: #f1f5f9;
                    color: #0f766e;
                    font-weight: 700;
                    border-bottom: 2px solid #cbd5e1;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    padding: 10px 12px;
                }
                .clinical-tutor-table td {
                    padding: 10px 12px;
                    vertical-align: middle;
                    font-size: 0.85rem;
                    border-bottom: 1px solid #e2e8f0;
                    color: #334155;
                }
                .clinical-tutor-table tbody tr.current-week-row td {
                    background-color: #f0fdfa;
                    font-weight: 500;
                }
                .flat-tutor-alert-box {
                    background: #f8fafc;
                    border-left: 4px solid #0f766e;
                    border-radius: 8px;
                }
                .pending-req-box {
                    background: #f0fdf4;
                    border: 1px solid #bbf7d0;
                    border-radius: 10px;
                }
            `}</style>

            <div>
                {/* Thông tin giảng viên */}
                <Card className="clinical-tutor-card p-3 mb-3 border-light">
                    <Row className="align-items-center">
                        <Col md={8}>
                            <div className="text-muted small font-weight-bold" style={{ color: '#0f766e' }}>GIẢNG VIÊN HƯỚNG DẪN LÂM SÀNG</div>
                            <h4 className="font-weight-bold text-dark mb-1 mt-1">{data?.giangVienTen || 'Giảng viên'}</h4>
                            <div className="text-muted small">
                                Khoa / Phòng: <strong>{data?.donViTen || 'Chưa phân khoa'}</strong>
                            </div>
                        </Col>
                        <Col md={4} className="text-md-right mt-2 mt-md-0 d-flex justify-content-end align-items-center" style={{ gap: '10px' }}>
                            {onNavigateToAttendance && (
                                <Button
                                    variant="success"
                                    size="sm"
                                    style={{ borderRadius: '6px', fontWeight: 'bold', backgroundColor: '#0d9488', borderColor: '#0d9488' }}
                                    onClick={onNavigateToAttendance}
                                >
                                    <i className="fas fa-check-double mr-1"></i> Điểm danh hôm nay
                                </Button>
                            )}
                            <Button 
                                variant="outline-teal" 
                                size="sm" 
                                style={{ borderRadius: '6px', fontWeight: 'bold', borderColor: '#0d9488', color: '#0f766e' }}
                                onClick={handleDownloadCsv}
                            >
                                <i className="fas fa-file-excel mr-1"></i> Xuất lịch biểu
                            </Button>
                        </Col>
                    </Row>
                </Card>



                {/* Bảng phân công hướng dẫn */}
                <h5 className="font-weight-bold text-dark mb-2 mt-3">
                    <i className="fas fa-list-alt mr-2 text-teal" style={{ color: '#0d9488' }}></i> Bảng phân công hướng dẫn lâm sàng chi tiết
                </h5>

                {nextWeeks.length === 0 ? (
                    <div className="alert alert-info shadow-xs border-light text-center py-4">
                        <i className="fas fa-calendar-times fa-2x mb-2 text-muted" style={{ opacity: 0.5 }}></i>
                        <div>Giảng viên này chưa được phân công lịch hướng dẫn lâm sàng nào.</div>
                    </div>
                ) : (
                    <>
                        <div className="table-responsive shadow-xs" style={{ borderRadius: '8px' }}>
                            <Table className="clinical-tutor-table mb-0">
                                <thead>
                                    <tr>
                                        <th style={{ width: '5%', textAlign: 'center' }}>STT</th>
                                        <th style={{ width: '25%' }}>Tuần thực hành</th>
                                        <th style={{ width: '30%' }}>Học viên lâm sàng</th>
                                        <th style={{ width: '20%' }}>Chuyên ngành</th>
                                        <th style={{ width: '10%' }}>Biến động</th>
                                        <th style={{ width: '10%', textAlign: 'center' }}>Trạng thái</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(() => {
                                        const paginatedWeeks = nextWeeks.slice((currentPage - 1) * pageSize, currentPage * pageSize);
                                        return paginatedWeeks.map((row, index) => {
                                            const isCurrent = tuanNayRange && row.rangeStr === tuanNayRange;
                                            return (
                                                <tr key={index} className={isCurrent ? "current-week-row" : ""}>
                                                    <td style={{ textAlign: 'center' }} className="font-weight-bold">{(currentPage - 1) * pageSize + index + 1}</td>
                                                    <td className="font-weight-bold text-dark">{row.rangeStr}</td>
                                                    <td className="font-weight-bold text-dark">{row.hocVienTen || 'Chưa phân công'}</td>
                                                    <td>{row.chuyenNganh || '-'}</td>
                                                    <td>
                                                        {row.isNewStudent ? (
                                                            <span className="tutor-badge-new">
                                                                <i className="fas fa-user-plus mr-1"></i> Mới
                                                            </span>
                                                        ) : (
                                                            <span className="tutor-badge-normal">Không có</span>
                                                        )}
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {isCurrent ? (
                                                            <span className="tutor-badge-current" style={{ backgroundColor: '#0d9488', color: '#fff', padding: '4px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 'bold' }}>Tuần hiện tại</span>
                                                        ) : (
                                                            <span className="tutor-badge-schedule">Lịch trình</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        });
                                    })()}
                                </tbody>
                            </Table>
                        </div>
                        {(() => {
                            const totalPages = Math.ceil(nextWeeks.length / pageSize);
                            return (
                                <div className="d-flex justify-content-between align-items-center mt-3 px-1">
                                    <div className="text-muted small">
                                        Hiển thị {nextWeeks.length > 0 ? (currentPage - 1) * pageSize + 1 : 0} - {Math.min(nextWeeks.length, currentPage * pageSize)} trong tổng số {nextWeeks.length} dòng
                                    </div>
                                    {totalPages > 1 && (
                                        <Pagination size="sm" className="mb-0" style={{ borderRadius: '6px' }}>
                                            <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                                            <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                                            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                                let pageNum;
                                                if (totalPages <= 5) {
                                                    pageNum = i + 1;
                                                } else {
                                                    pageNum = currentPage - 2 + i;
                                                    if (currentPage <= 2) pageNum = i + 1;
                                                    if (currentPage >= totalPages - 1) pageNum = totalPages - 4 + i;
                                                }
                                                if (pageNum < 1) pageNum = 1;
                                                if (pageNum > totalPages) return null;
                                                return (
                                                    <Pagination.Item
                                                        key={pageNum}
                                                        active={pageNum === currentPage}
                                                        onClick={() => setCurrentPage(pageNum)}
                                                    >
                                                        {pageNum}
                                                    </Pagination.Item>
                                                );
                                            })}
                                            <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                                            <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
                                        </Pagination>
                                    )}
                                </div>
                            );
                        })()}
                    </>
                )}

                {/* Ghi chú biến động nhân sự */}
                {data?.ghiChuThayDoi && (
                    <Card className="flat-tutor-alert-box border-light p-3 mt-3">
                        <div className="d-flex align-items-start" style={{ gap: '10px' }}>
                            <i className="fas fa-info-circle text-teal" style={{ color: '#0f766e', fontSize: '1.1rem' }}></i>
                            <div>
                                <div className="font-weight-bold text-dark small">Ghi chú biến động nhân sự sắp tới</div>
                                <div className="text-muted small mt-1" style={{ lineHeight: '1.4' }}>{data.ghiChuThayDoi}</div>
                            </div>
                        </div>
                    </Card>
                )}
            </div>
        </div>
    );
};

export default InstructorAgendaView;
